import { buildFullAddress } from '@hacktoolkit/nextjs-htk/utils';

export const BUSINESS = {
  domain: 'tearekz.cafe',
  name: "Tea-Rek'z",
  branding: {
    welcome: 'Welcome to',
    tagline:
      'Premium Boba & Specialty Beverages in Historic Niles, Fremont — Made with Real Ingredients and No Artificial Non-Dairy Creamer.',
    slogan:
      'Dino-mite Boba & Tea - Fresh, Handcrafted Drinks in Historic Niles, Fremont, California',
  },
  founding: {
    year: 2025,
  },
  location: {
    address: '37390 Niles Blvd',
    city: 'Fremont',
    state: 'CA',
    zip: '94536',
    neighborhood: 'Niles',
    country_abbrev: 'US',
    lat: 37.5773115,
    lng: -121.9802536,
    phone: '(510) 793-8161',
  },
  contact: {
    email: 'hello@tearekz.cafe',
    careersEmail: 'hr@skilletz.cafe',
  },
  hours: {
    mondayToTuesday: {
      days: 'Monday - Tuesday',
      dayList: ['Monday', 'Tuesday'],
      open: '12:00',
      close: '19:00',
      display: '12pm - 7pm',
    },
    wednesday: {
      days: 'Wednesday',
      dayList: ['Wednesday'],
      open: '00:00',
      close: '00:00',
      display: 'Closed',
    },
    thursday: {
      days: 'Thursday',
      dayList: ['Thursday'],
      open: '12:00',
      close: '20:00',
      display: '12pm - 8pm',
    },
    friday: {
      days: 'Friday',
      dayList: ['Friday'],
      open: '12:00',
      close: '20:00',
      display: '12pm - 8pm',
    },
    saturday: {
      days: 'Saturday',
      dayList: ['Saturday'],
      open: '10:00',
      close: '20:00',
      display: '10am - 8pm',
    },
    sunday: {
      days: 'Sunday',
      dayList: ['Sunday'],
      open: '10:00',
      close: '20:00',
      display: '10am - 8pm',
    },
  },
} as const;

export const FULL_ADDRESS = buildFullAddress(BUSINESS.location);
